<template>
  <div>
    <el-upload
        class="upload-hide"
        action="url"
        :on-preview="preview"
        :on-remove="remove"
        :file-list="fileList">
    </el-upload>
  </div>
</template>

<script>

  import { downloadURI } from 'src/common/helper'

  export default {
    props: {
      fileList: Array,
      url: String
    },

    methods: {
      preview({ url, name }) {
        downloadURI(url, name)
      },

      remove({ id }) {
        this.$axios.delete(`${this.url}/docs/${id}.json`)
      }
    }
  }
</script>
